import { render, staticRenderFns } from "./AssignSelect.vue?vue&type=template&id=a40f693c&"
import script from "./AssignSelect.vue?vue&type=script&lang=js&"
export * from "./AssignSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports